"use client";

import { createContext, useContext } from "react";

export interface IFeatureFlagsContextValue {
  ready: boolean;
  flags: Record<string, string | boolean>;
}

export const FeatureFlagsContext = createContext<IFeatureFlagsContextValue | null>(null);

export const useFeatureFlagsContext = (): IFeatureFlagsContextValue => {
  const ctx = useContext(FeatureFlagsContext);
  if (!ctx) {
    throw new Error(
      "useFeatureFlagsContext must be used within a <FeatureFlagsProvider>",
    );
  }
  return ctx;
};
